const SELECTOR =
  '.services-availability, .emergency-contact, .gallery-image, .vehicle-information, .seller-vehicles, [data-service-addresses], .checkout-items';

class Hints {
  constructor() {
    if ($(SELECTOR)) {
      this.attachEventHandlers();
    }
  }

  attachEventHandlers() {
    $(SELECTOR).on('cocoon:after-insert', (event, addedElement) => {
      $(addedElement)
        .find('.form-group .help-block.hint')
        .each((i, element) => {
          let content = $(element)
            .text()
            .replace(/"/g, '&quot;');
          let toggler = $(
            '<button type="button" class="hint-toggler" data-toggle="tooltip" title="' +
              content +
              '">Toggle hint</button>'
          );
          let context = $(element)
            .closest('.form-group')
            .find('label.control-label');
          context.append(toggler);
          $(toggler).tooltip();
        });
    });
  }
}

export default Hints;



// WEBPACK FOOTER //
// ./src/javascripts/Hints.js